var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobCalibraPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1a18;}.cls-2{fill:#fff145;}.cls-3{fill:#14635b;}.cls-4{fill:#d3ba09;}.cls-5{fill:#fff;}.cls-6{fill:#ff4800;}.cls-7{fill:#1c7f78;}.cls-8{fill:aqua;}.cls-9{fill:#0f4c45;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.41 191.6 107.51 191.6 41.88 210.35 33.37 299.8 267.56 299.8 259.04 210.35 193.41 191.6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.88 210.35 33.37 299.8 47 299.8 50 225.73 41.88 210.35"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "40 227 106 237 106 182 0 182 40 227"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "259.99 210.55 268.5 300 254.87 300 251.87 225.93 259.99 210.55"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "161 290 151.16 295 141 290 111 211 191 211 161 290"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "260 227 194 237 194 182 300 182 260 227"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "202 241 152.16 261 101 241 61 177 151.71 157 242 177 202 241"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "162.57 237.91 150.74 241.45 138.91 237.91 116.1 203.85 51.04 165.41 108.2 131.61 185.49 131.61 250.44 165.41 185.38 203.85 162.57 237.91"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "233.28 40.67 229.05 33.07 170.12 69.65 132.14 69.65 73.01 33.29 68.78 40.9 74.99 100.09 51.46 163.49 107.92 159.83 130.64 162.03 141.12 214.79 161.14 214.79 171.45 162.03 193.64 159.83 250.8 163.49 227.62 100.04 233.28 40.67"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "193.19 161.75 171.02 163.72 174.96 145.01 209.88 140.84 193.19 161.75"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "151.16 223.48 141.2 214.52 151.16 211.32 161.12 214.52 151.16 223.48"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "108.94 161.97 131.12 163.94 127.17 145.22 94.79 141.05 108.94 161.97"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "68.78 42.9 74.66 101.23 95.82 83.45 68.78 42.9"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "233.28 42.67 227.4 101.01 206.24 83.23 233.28 42.67"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "161 117 150.46 127 141 117 137 68 165 68 161 117"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "57 159.78 35 149.78 35 108.78 57 98.78 57 159.78"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "50 168.67 42 88.64 74 98.64 79 158.67 124.61 212.41 119 228 50 168.67"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "244 159.78 266 149.78 266 108.78 244 98.78 244 159.78"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "222 158.67 227 98.64 259 88.64 251 168.67 183 228 176.94 212.41 222 158.67"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58 95 74 98.64 79 158.67 125 212 70 163 58 95"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82 137 63 121 20 12 63 33 101 68 82 137"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "227.09 56.35 151.33 88.35 72.57 56.35 62.57 39.78 150.69 5.35 237.09 39.78 227.09 56.35"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.67 94.92 226.67 98.56 221.67 158.58 177 212 230.67 162.92 242.67 94.92"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "218 137.35 238 122 280 12.35 237 33.35 199 68 218 137.35"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "227.09 47 151.33 79 72.57 47 62.57 33.43 150.69 -1 237.09 33.43 227.09 47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCalibraPilot);
export default __webpack_public_path__ + "static/media/mob-calibra-pilot.469c82bad911b0e40f8e3a0ce10111c5.svg";
export { ForwardRef as ReactComponent };